import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

function FavoritesTabs({ onTabSelect }) {
  const [selectedTab, setSelectedTab] = useState("DietItems");
  
  const handleTabSelect = (key) => {
    if (!key) return;
    setSelectedTab(key);
    onTabSelect(key);
  };

  return (
    <div className="favoritesTabs">
      <Tabs
        id="favorites-tabs"
        activeKey={selectedTab}
        onSelect={handleTabSelect}
        className="mb-3"
        justify
      >
        <Tab
          eventKey="DietItems"
          title={<span style={{ color: "#000" }}>Diet Items</span>}
        />
        <Tab
          eventKey="tips"
          title={<span style={{ color: "#000" }}>Tips &amp; Guide</span>}
        />
      </Tabs>
    </div>
  );
}

export default FavoritesTabs;
